import { useConfigStore } from '@/store/config.store';
import type { IProduct } from '@/domain/product/IProduct';
import type { Product } from '@/domain/product/Product';
import type { IProductStateRepository } from '@/application/ports/IProductStateRepository';

class PiniaProductStateRepository implements IProductStateRepository {
    getProduct(): Product | null {
        return useConfigStore().product;
    }

    patchProduct(patch: Partial<IProduct>): void {
        useConfigStore().patchProduct(patch);
    }
}

export { PiniaProductStateRepository };
